import React, { Fragment, useEffect } from "react";

import Security  from "~/services/security";
import useScript from 'react-script-hook';

const ApplixirVideo = ({overlayOpen, setLoading, setCheckinType, setMessage, setOverlayOpen, verifyCheckIn, setOverlayType})=> {

  const [loading] = useScript({src: "https://cdn.applixir.com/applixir.sdk3.0m.js"});

  useEffect(()=> {
    if(!overlayOpen) return;

    !loading && startVideo();
  }, [loading, overlayOpen]);

  const startVideo = ()=> {
    setLoading(true);
    window.invokeApplixirVideoUnit({
      userId    : Security.currentUserValue.id,
      zoneId    : 4845,
      accountId : 6214,
      gameId    : 7017,
      adStatusCb: (status)=> {
        if(status == 'ads-unavailable') return setCheckinType('hcaptcha');
        if(status == 'ad-interrupted') {
          setLoading(false);
          setOverlayOpen(false);
          return;
        };
        if(status != 'ad-rewarded') return;
        setTimeout(()=> {
          verifyCheckIn();
          setLoading(false);
          setMessage('Bonus Granted');
          setOverlayType('claimed');
        }, 2000);
      }
    });
  };

  return (
    <Fragment>
      <div id="applixir_vanishing_div" hidden style={{zIndex: 100}}>
        <iframe id="applixir_parent" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"> </iframe>
      </div>
    </Fragment>
  );
};

export default ApplixirVideo;
